











































































































































































































import { Component, Vue, Ref } from 'vue-property-decorator';
import { employeeApis, InvalidParam, LoginResult, ResetPasswordForm, qrcodeApis, Qrcode, Employee } from '../api';
import { QrcodeIndexPathName } from '@/common/index';
import * as dd from 'dingtalk-jsapi';
import { AESFunction } from '@/common/cryptoAES';
import { CookieFunction } from '@/common/cookie';
import { getRedirectUrl, isSamlLogin } from '@/common';
import { DingtalkCorpId, isInDingtalk } from '@/common/dingtalk';

// @ts-ignore
import $ from 'jquery';
// @ts-ignore
import QRCode from 'qrcode';

declare const CAPTCHA_SCENE_ID: string;
declare const EMPLOYEE: Employee;

@Component
export default class LoginNew extends Vue {
  @Ref('qrcodeCanvas') qrcodeCanvas!: HTMLElement;

  readonly rules = {
    username: { required: true, message: '请输入账号', trigger: 'blur' },
    code: { required: true, message: '请输入验证码', trigger: 'blur' },
    new_password: { required: true, message: '请输入密码', trigger: 'blur' },
    repeat_new_password: {
      required: true,
      validator: (rule: any, value: any, callback: any) => {
        if (value !== this.resetForm.new_password) {
          callback(new Error('新密码重复输入不一致'));
        } else {
          callback();
        }
      },
      trigger: 'blur'
    }
  };

  errors: Record<string, any> = {};
  form = { username: '', passwd: '', remerber: false };
  resetForm: ResetPasswordForm = {
    username: '',
    new_password: '',
    repeat_new_password: '',
    code: null,
    email: '',
    send_code: false
  };

  corpId = DingtalkCorpId;
  forgotPassword = false;
  timer: number | null = null;
  countDownNum = 60;
  codeDisable = false;
  pubKey = '';

  captcha: any = null;
  captchaButtonEle: HTMLElement | null = null;
  loginResult: any = null;
  loginLoading = false;
  loginTimes = 1;

  // 二维码登录相关
  isQRCodeLogin = false;
  qrCodeData: Qrcode = {} as Qrcode;
  qrCodeLoading = false;
  qrCodeExpired = false;
  qrCodeStatus: 'waiting' | 'scanned' | 'confirmed' | 'expired' = 'waiting';
  qrCodeTimer: number | null = null;
  qrCodePollTimer: number | null = null;
  qrCodeDataUrl = '';
  qrCodeState = '';

  async mounted() {
    if (EMPLOYEE && EMPLOYEE.id) {
      this.routeTo();
      return;
    }

    // 钉钉环境自动登录
    if (isInDingtalk()) {
      this.loginByDD();
      return;
    }

    // 读取记住的密码
    if (CookieFunction.getCookie('username') && CookieFunction.getCookie('passwd')) {
      this.form.username = CookieFunction.getCookie('username');
      this.form.passwd = AESFunction.decrypt(CookieFunction.getCookie('passwd'));
      this.form.remerber = true;
    }

    // 初始化验证码
    if (!this.captcha) {
      this.initCaptcha();
    }
  }

  beforeDestroy() {
    this.captchaButtonEle = null;
    // 清理验证码元素
    document.getElementById('aliyunCaptcha-mask')?.remove();
    document.getElementById('aliyunCaptcha-window-popup')?.remove();

    // 清理定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    // 清理二维码相关定时器
    this.clearQRCodeTimers();
  }

  clearQRCodeTimers() {
    if (this.qrCodeTimer) {
      clearTimeout(this.qrCodeTimer);
      this.qrCodeTimer = null;
    }
    if (this.qrCodePollTimer) {
      clearInterval(this.qrCodePollTimer);
      this.qrCodePollTimer = null;
    }
  }

  initCaptcha() {
    this.captchaButtonEle = document.getElementById('login-button');

    // @ts-ignore
    window.initAliyunCaptcha({
      SceneId: CAPTCHA_SCENE_ID,
      prefix: process.env.VUE_APP_CAPTCHA_PREFIX,
      mode: 'popup',
      element: '#captcha-element',
      button: '#login-button',
      captchaVerifyCallback: this.captchaVerifyCallback,
      onBizResultCallback: this.onBizResultCallback,
      getInstance: this.getInstance,
      slideStyle: {
        width: 320,
        height: 40
      },
      language: 'cn'
    });
  }

  loginByDD() {
    dd.ready(() => {
      dd.runtime.permission
        .requestAuthCode({
          corpId: this.corpId
        })
        .then(async (info: any) => {
          const code = info.code;
          const result = await employeeApis.loginByDingtalk(code);
          this.updateEmployee(result);
          this.routeTo();
        });
    });
  }

  get isSAML() {
    return isSamlLogin(this.$route);
  }

  updateEmployee(result: LoginResult) {
    this.$store.commit('employee/update', result.employee);
    this.$store.commit('perms/update', result.perms);
  }

  routeTo() {
    if (typeof this.$route.query.redirect === 'string') {
      const redirect_url = getRedirectUrl(this.$route);
      if (redirect_url && typeof redirect_url === 'string') {
        if (redirect_url.slice(0, 4) === 'http') {
          window.open(redirect_url, '_self');
          return;
        } else {
          this.$router.push(redirect_url);
          return;
        }
      }
    }
    this.$router.push('/');
  }

  login() {
    // @ts-ignore
    this.$refs['loginForm'].validate((valid: boolean) => {
      if (valid) {
        this.captchaButtonEle?.click();
      }
    });
  }

  async loginWithCaptcha(captcha: any): Promise<{ bizResult: boolean; captchaResult: boolean }> {
    this.errors = {};
    const encryptStr = new this.$jsEncrypt();
    const pubKeyResult = await employeeApis.getPublicKey();
    this.pubKey = pubKeyResult.key;
    const timestamp1 = pubKeyResult.timestamp;
    encryptStr.setPublicKey(this.pubKey);
    const data = encryptStr.encrypt(this.form.passwd.toString() + '&' + timestamp1);
    const loginForm = { username: this.form.username, passwd: data };
    this.loginResult = null;
    this.loginLoading = true;

    try {
      if (this.isSAML) {
        this.loginResult = await employeeApis.loginSaml(loginForm);
      } else {
        this.loginResult = await employeeApis.loginWithCaptcha(loginForm, captcha, this.loginTimes);
      }
      return { bizResult: true, captchaResult: true };
    } catch (e) {
      const result = { bizResult: false, captchaResult: true };
      if (e instanceof InvalidParam) {
        if (e.captcha_error()) {
          result.captchaResult = false;
        } else {
          this.errors = e.params;
          CookieFunction.clearLoginForm();
        }
        if (e.captcha_retry()) {
          this.login();
        }
      } else {
        this.$notify.error({ title: '错误', message: e.message });
      }
      return result;
    } finally {
      this.loginTimes += 1;
      this.loginLoading = false;
    }
  }

  reset_passwd() {
    // @ts-ignore
    this.$refs['resetForm'].validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      try {
        const encryptStr = new this.$jsEncrypt();
        const pubKeyResult = await employeeApis.getPublicKey();
        this.pubKey = pubKeyResult.key;
        const timestamp = pubKeyResult.timestamp;
        encryptStr.setPublicKey(this.pubKey);
        const new_data = encryptStr.encrypt(this.resetForm.new_password.toString() + '&' + timestamp);
        const new_repeat_data = encryptStr.encrypt(this.resetForm.repeat_new_password.toString() + '&' + timestamp);
        const resetForm = {
          username: this.resetForm.username,
          new_password: new_data,
          repeat_new_password: new_repeat_data,
          code: this.resetForm.code,
          email: this.resetForm.email,
          send_code: this.resetForm.send_code
        };
        const res = await employeeApis.resetPassword(resetForm);
        this.updateEmployee(res);
        if (CookieFunction.getCookie('username') && CookieFunction.getCookie('passwd')) {
          CookieFunction.updateLoginForm(undefined, AESFunction.encrypt(this.resetForm.new_password));
        }
        // 如果是内部员工提示一下密码的用途
        if (!this.$currentIsExternal()) {
          try {
            await this.$alert(this.$passwordTips, '提示', {
              confirmButtonText: '确认并继续',
              type: 'warning'
            });
          } catch {}
        }

        this.routeTo();
        this.$notify.success({ title: '成功', message: '密码已重新设置成功，自动登录' });
      } catch (e) {
        if (e instanceof InvalidParam) {
          this.errors = e.params;
          this.$message.error(Object.values(e.params).join('/'));
        } else {
          this.$notify.error({ title: '错误', message: e.message });
        }
      }
    });
  }

  async sendEmailCode() {
    const TIME_COUNT = 60;
    this.codeDisable = true;
    this.countDownNum = TIME_COUNT;
    this.resetForm.send_code = true;
    try {
      const result = await employeeApis.getEmailCode(this.resetForm);
      this.resetForm.email = (result as any).email;
      this.$notify.success({ title: '成功', message: `验证码已发送至${this.resetForm.email}` });
    } catch (e) {
      if (e instanceof InvalidParam) {
        this.errors = e.params;
      } else {
        this.$notify.error({ title: '错误', message: e.message });
      }
      this.codeDisable = false;
      return;
    }
    this.timer = setInterval(() => {
      if (this.countDownNum > 0 && this.countDownNum <= TIME_COUNT) {
        this.countDownNum--;
      } else {
        this.codeDisable = false;
        clearInterval(this.timer as number);
        this.timer = null;
      }
    }, 1000);
  }

  setUserInfo() {
    if (this.form.remerber) {
      CookieFunction.updateLoginForm(this.form.username, AESFunction.encrypt(this.form.passwd));
    }
  }

  getInstance(instance: any) {
    this.captcha = instance;
  }

  async captchaVerifyCallback(captchaVerifyParam: Record<string, any>) {
    return await this.loginWithCaptcha(captchaVerifyParam);
  }

  onBizResultCallback(bizResult: boolean) {
    if (bizResult && this.loginResult) {
      if (this.loginResult.html) {
        this.setUserInfo();
        $('html').html(this.loginResult.html);
        document.forms[0].submit();
      } else {
        this.updateEmployee(this.loginResult);
        this.routeTo();
        this.setUserInfo();
      }
    }
  }

  // ========== 二维码登录相关方法 ==========

  /**
   * 切换登录方式
   */
  switchLoginType(isQRCode: boolean) {
    this.isQRCodeLogin = isQRCode;
    this.errors = {};

    if (isQRCode) {
      // 切换到二维码登录，获取二维码
      this.getQRCode();
    } else {
      // 切换到账号登录，清理二维码相关
      this.clearQRCodeTimers();
      this.qrCodeData = {} as Qrcode;
      this.qrCodeStatus = 'waiting';
      this.qrCodeExpired = false;
    }
  }

  /**
   * 获取二维码
   */
  async getQRCode() {
    this.qrCodeLoading = true;
    this.qrCodeExpired = false;
    this.qrCodeStatus = 'waiting';
    this.qrCodeState = Math.random()
      .toString(36)
      .substring(2, 15); // 生成随机 state

    try {
      const result = await qrcodeApis.getQrcodeUrl(this.qrCodeState);

      this.qrCodeData = result;
      const { href } = this.$router.resolve({
        name: QrcodeIndexPathName,
        query: { qrcode_id: result.qrcode_id }
      });
      const absoluteURL = new URL(href, window.location.origin).href;
      // console.log(absoluteURL);
      QRCode.toDataURL(
        absoluteURL,
        {
          width: 200,
          margin: 2
        },
        (err: any, url: any) => {
          if (err) throw err;
          this.qrCodeDataUrl = url;
        }
      );

      // 设置二维码过期定时器
      this.qrCodeTimer = setTimeout(() => {
        this.qrCodeExpired = true;
        this.qrCodeStatus = 'expired';
        this.clearQRCodeTimers();
      }, result.expire_in * 1000);

      // 开始轮询二维码状态
      this.startQRCodePolling();
    } catch (e) {
      console.warn(e);
      this.$notify.error({ title: '错误', message: '获取二维码失败，请重试' });
    } finally {
      this.qrCodeLoading = false;
    }
  }

  /**
   * 刷新二维码
   */
  refreshQRCode() {
    this.clearQRCodeTimers();
    this.getQRCode();
  }

  /**
   * 开始轮询二维码状态
   */
  startQRCodePolling() {
    // 每2秒轮询一次
    this.qrCodePollTimer = setInterval(async () => {
      try {
        const result = await qrcodeApis.getQrcodeStatus(this.qrCodeData.qrcode_id, this.qrCodeState);
        const status = result.status;

        if (status === 'scanned') {
          // 已扫描，等待确认
          this.qrCodeStatus = 'scanned';
        } else if (status === 'confirmed') {
          // 已确认，登录成功
          this.qrCodeStatus = 'confirmed';
          this.clearQRCodeTimers();
          this.$notify.success({ title: '成功', message: '扫码登录成功,即将开始跳转' });
          setTimeout(() => {
            this.routeTo();
          }, 800);
        } else if (status === 'expired' || status === 'missing') {
          // 已过期
          this.qrCodeExpired = true;
          this.qrCodeStatus = 'expired';
          this.clearQRCodeTimers();
        } else if (status === 'invalid') {
          // 状态无效
          this.$notify.error({ title: '错误', message: `二维码状态无效 ${result.message}` });
          this.qrCodeExpired = true;
          this.qrCodeStatus = 'expired';
          this.clearQRCodeTimers();
        } else {
          // 其他状态保持等待
          this.qrCodeStatus = 'waiting';
        }
      } catch (e) {
        console.error('轮询二维码状态失败:', e);
      }
    }, 2000);
  }
}
